/**
 * Marker.io Integration
 * Visual feedback and bug reporting tool
 * 
 * SECURITY: Only loaded in staging environment
 * MUST NEVER be enabled in production
 */

declare global {
  interface Window {
    markerConfig?: {
      project: string;
      source: string;
    };
    __Marker?: any;
    Marker?: any;
  }
}

/**
 * Initialize Marker.io for visual feedback and bug reporting
 * 
 * SECURITY RULES:
 * - ONLY runs when VITE_ENVIRONMENT === 'staging'
 * - EXPLICITLY BLOCKED for 'production'
 * - EXPLICITLY BLOCKED for 'development' (to avoid accidental production leaks)
 * - MUST NEVER be enabled in production environment
 */
export function initializeMarker(): void {
  const environment = import.meta.env.VITE_ENVIRONMENT;

  // CRITICAL: Explicitly block production
  if (environment === 'production') {
    console.error('[Marker.io] BLOCKED: Marker.io is disabled in production');
    return;
  }

  // CRITICAL: Only allow staging - reject everything else
  if (environment !== 'staging') {
    // Silent return for development, but log for visibility
    if (import.meta.env.DEV) {
      console.log('[Marker.io] Not loaded in development environment');
    }
    return;
  }

  // Set up marker configuration
  window.markerConfig = {
    project: '69e18d9eb9170bab146b6195',
    source: 'snippet',
  };

  // Load marker.io script
  if (!window.__Marker) {
    window.__Marker = {};
    const t: any[] = [];
    const n: any = { __cs: t };

    [
      'show',
      'hide',
      'isVisible',
      'capture',
      'cancelCapture',
      'unload',
      'reload',
      'isExtensionInstalled',
      'setReporter',
      'clearReporter',
      'setCustomData',
      'on',
      'off',
    ].forEach(function (e) {
      n[e] = function () {
        const r = Array.prototype.slice.call(arguments);
        r.unshift(e);
        t.push(r);
      };
    });

    window.Marker = n;

    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://edge.marker.io/latest/shim.js';
    const i = document.getElementsByTagName('script')[0];
    if (i && i.parentNode) {
      i.parentNode.insertBefore(s, i);
    }

    console.log('[Marker.io] Initialized for staging environment');
  }
}
